import loadable from 'components/dynamic-import';

const Achievements = loadable(() => import('./Achievements'));

export default Achievements;
